module.exports = __webpack_public_path__ + "img/Avatar-Placeholder-400x400-1.5ec8819c.jpg";